<template>
<!-- <div class="subject padding-20 bgc box-shadow"> -->
<div class="subject">
    <router-view></router-view>
    <!-- <keep-alive include="subjectList">
        <router-view></router-view>
    </keep-alive> -->
</div>
</template>

<script>
export default {
    name: 'subject',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {
    },
    filters: {
    },
    watch: {},
    computed: {
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.subject {
    // min-width: 1200px;
    .el-pagination{
        margin-top: 20px;
        text-align: center;
    }
    .text-ellipses {
        height: 40px;
        line-height: 20px;
        overflow: hidden;
        text-align: left;
        .text {
            float: right;
            margin-left: -10px;
            width: 100%;
            word-break: break-all;
            text-align: left;
            font-size: 14px;
        }
        &::before {
            float: left;
            content: '';
            width: 10px;
            height: 100%;
        }
        &::after {
            float: right;
            content: "...";
            height: 40px;
            line-height: 20px;
            width: 37px;
            margin-left: -37px;
            position: relative;
            left: 101.9%;
            bottom: 20px;
            font-weight: 600;
            padding-right: 1px;
            background: #fff;
            transition: all 0.5s;
            text-align: left;
        }
    }
}
</style>
